export const group = {
  groups: "Groups",
  groupColumn: "Group",
  groupsLabel: "Group(s):",
  noGroups: "No groups",
  showSchoolWideGroups: "Show school-wide groups",
  schoolWideGroupActionsDisabled: "School groups are managed from School Groups",
  // Scope chip label (Class/School) on GroupCard.
  filterSectionClass: "Class",
  filterSectionSchool: "School",

  // Groups tab
  moreMembers: "+ {{count}} MORE",
  moreGroups: "+{{count}}",
  noStudentsAdded: "You don't have any students added",
  addGroup: "Add Group",
  selectAll: "Select all",
  editGroups: "Edit groups",
  exitEditMode: "Exit edit mode",
  createNewGroup: "Create new group",
  export: "Export",
  filter: "Filter",
  groupFilterMenuItem: "Group filter",
  groupFilterNoGroupsTooltip: "Create a group to activate the filter",
  moreOptions: "More options",
  exportGenerateReport: "Generate new report",
  exportNoRecords: "No transaction records",
  exportStoreByGroup: "Store purchases by group",
  exportStoreByGroupNoGroups: "This class has no groups",
  exportStoreByGroupPicker: "Groups in the report",
  exportStoreByGroupAll: "All groups ({{count}})",
  exportStoreByGroupSome: "{{selected}} of {{count}} groups",
  exportStoreByGroupNoneSelected: "Select at least one group",

  // Group filter
  displayGroups: "Display groups",
  groupFilters: "Group filters",
  selectGroupsToDisplay: "Select the groups you want to display",
  selectGroupsToDisplayStudents:
    "Select the groups whose students you want to display",
  resetFilters: "Reset filters",
  apply: "Apply",
  allGroupsHiddenTitle: "All groups are hidden",
  allGroupsHiddenDescription:
    "Adjust your filters to display the groups you're interested in",
  noStudentsMatchGroupFilter: "No students in the selected groups",
  editGroup: "Edit group",
  deleteGroup: "Delete group",
  viewMembers: "View members",
  noMembers: "No members yet",
  deleteSelected: "Delete group(s)",

  emptyTitle: "You don't have any groups",
  emptySubtitle: "Try to create your first group",
  schoolGroupsEmptySubtitle:
    "School-wide groups you create here will be available across every class in your school",

  deleteDialogTitle: "Are you sure you want to delete selected group(s)?",
  deleteDialogWarning: "This option cannot be undone.",
  deleteDialogConfirm: "Delete",
  groupDeletedSuccess: "Group has been deleted successfully",
  groupsDeletedSuccess: "Groups have been deleted successfully",

  // Create group flow
  groupNameLabel: "Group title",
  searchStudentLabel: "Search student",
  createGroupCta: "Create group",
  groupCreatedSuccess: "Group has been created successfully",
  groupUpdatedSuccess: "Group has been updated successfully",
  backendError: "{{message}}",
  membersLoadError: "Couldn't load all group members",
  retry: "Try again",

  upgradeTitle: "Upgrade to unlock Groups",
  upgradePlansNote:
    "Grouping is a feature included in the 'Pro Subscription' and 'School Subscription'. Learn more about our <Link>paid plans here</Link>. Upgrade to pro or school to unlock this feature.",
  upgradeCta: "Upgrade",

  // Import group(s) flow
  importGroups: "Import group(s)",
  importGroupsDescription:
    "Upload a .xlsx file to import your groups - use the <Link>sample template</Link>, or re-upload an edited groups export file.",
  selectFileToUpload: "Select file to upload",
  clearSelectedFile: "Clear selected file",
  import: "Import",
  importFailed: "Import failed",
  importTemplateFilename: "Group Import Template",
  importedCount: "{{count}} group(s) imported",
  skippedGroupsTitle: "Skipped (name already exists)",
  skippedSchoolWideRowsCount:
    "{{count}} school-wide group row(s) were skipped (not importable into a class)",
  importReviewTitle: "Fix these rows before importing",
  importReviewDescription:
    "This file has rows that can't be imported yet. Fix them in the file and re-upload, or import the rest now and leave these out.",
  importAnyway: "Import anyway",
  invalidRowsTitle: "Rows to fix:",
  unmatchedRowsTitle: "Rows with no matching student:",
  importIssueLine: "Row {{row}} ({{column}})",
  importReasonMissingIdentifier: "Missing student identifier",
  importReasonGroupNameTooLong: "Group name is too long",
  importReasonStudentNotFound:
    "No student in this class matches this identifier",
  importReasonStudentNotFoundSchool:
    "No student in this school matches this identifier",

  // Import mode: "Create groups and add missing students" (SCHOOL plan, class import)
  importModeCreateGroups: "Create groups",
  importModeCreateGroupsDescription:
    "Group students who are already in this class. The class roster stays unchanged.",
  importModeAddMissingStudents: "Create groups and add missing students",
  importModeAddMissingStudentsDescription:
    "Also adds students from your school who aren't in this class yet. You'll see who will be added before anything is saved.",
  importGroupsAddMissingStudentsDescription:
    "Upload a .xlsx file to import your groups - use the <Link>sample template</Link>, or re-upload an edited groups export file. To add students who aren't in this class, add a row with their email or login.",
  importPreviewTitle: "Review import",
  importPreviewNothingSaved: "Nothing has been saved yet.",
  importPreviewStudentsToAdd: "Students to add",
  importPreviewGroupsToCreate: "New groups",
  importPreviewExistingGroups:
    "These groups already exist and won't be changed:",
  importPreviewSkippedRows: "Skipped rows",
  importPreviewSkippedRowsDescription_one: "This row can't be imported.",
  importPreviewSkippedRowsDescription_other: "These rows can't be imported.",
  importPreviewShowRows: "Show rows",
  importPreviewHideRows: "Hide rows",
  importPreviewNothingToImport:
    "Nothing to import. This file doesn't add any students or create any groups.",
  importPreviewUploadAnother: "Upload another file",
  importConfirmAddStudents_one: "Add {{count}} student",
  importConfirmAddStudents_other: "Add {{count}} students",
  importConfirmCreateGroups_one: "Create {{count}} group",
  importConfirmCreateGroups_other: "Create {{count}} groups",
  importConfirmAndCreateGroups_one: "and create {{count}} group",
  importConfirmAndCreateGroups_other: "and create {{count}} groups",
  importCompleteTitle: "Import complete",
  importCompleteGroupsCreated: "Groups created: {{count}}",
  importCompleteStudentsAdded: "Students added: {{count}}",
  importCompleteRowsSkipped: "Rows skipped: {{count}}",
  importSyncedClassWarning:
    "This class is synced with your roster. Students you add here are not part of the sync - they won't be removed when the roster changes, so you manage them by hand.",
}
